import { render, staticRenderFns } from "./AddOrderProducts.vue?vue&type=template&id=f049a71c&"
import script from "./AddOrderProducts.vue?vue&type=script&lang=js&"
export * from "./AddOrderProducts.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports